import styled from 'styled-components';

export const FieldContainerBankFields = styled.div<{ $isSingleRowField?: boolean }>`
  ${({ $isSingleRowField }) =>
    $isSingleRowField ? `margin-bottom: 32px !important` : 'margin-bottom: 16px !important'};
`;
